import type { components } from '@/types/api/v1'
import { ArrowRightOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'

type CrossroadsRoutingInfo = components['schemas']['CrossroadsRoutingInfo']

/** Origin -> destination tenant names, with a tooltip for the underlying instance names. */
export function RoutingCell({
  routing,
}: {
  routing: CrossroadsRoutingInfo | null | undefined
}) {
  if (!routing) return null
  return (
    <Horizontal gap={6} alignItems='center'>
      <Texto>{routing.origin_tenant_name}</Texto>
      <ArrowRightOutlined
        style={{ color: 'var(--theme-text-hint)', fontSize: 12 }}
      />
      <Texto>{routing.destination_tenant_name}</Texto>
      <Tooltip
        title={`${routing.origin_instance_name} → ${routing.destination_instance_name}`}
      >
        <InfoCircleOutlined
          style={{ color: 'var(--theme-text-hint)', fontSize: 12 }}
        />
      </Tooltip>
    </Horizontal>
  )
}
